const headerDataDespatchupdate = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 120,
  },
  {
    prop: "InvCode",
    label: "存货代码",
    columnwidth: 120,
  },
  {
    prop: "InvName",
    label: "存货名称",
    columnwidth: 120,
  },
  {
    prop: "Batch",
    label: "批号",
    columnwidth: 120,
  },
  {
    prop: "ValiDate",
    label: "有效期",
    columnwidth: 120,
  },
  {
    prop: "Quantity",
    label: "数量",
    columnwidth: 120,
  },
  {
    prop: "TaxUnitPrice",
    label: "含税单价",
    columnwidth: 120,
  },
  {
    prop: "TaxUnitPriceSum",
    label: "价税合计",
    columnwidth: 120,
  },
  {
    prop: "VouCode",
    label: "经销商单据号",
    columnwidth: 120,
  },
  {
    prop: "VouDCode",
    label: "明细行号",
    columnwidth: 120,
  },
];

export default headerDataDespatchupdate
